import { Pipe, PipeTransform } from '@angular/core';

import { contatoTipos } from '../pessoa-contato-tipo';

@Pipe({
    name: 'pessoaContatoTipoPrimario'
})
export class PessoaContatoTipoPrimarioPipe implements PipeTransform {
    transform(value: number): boolean {
        if (!value) {
            return false;
        }

        const index = contatoTipos.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return contatoTipos[index].primario;
        }
        return false;
    }
}
